import type { Slide } from '@features/powerpoint';
import { inmarketLogo } from '@features/powerpoint/images';
import { themeV2 } from '../../domain/theme-v2';
import { DEFAULT_FONT } from '../../utils/constants-v2';
import { SECTION_HEADER_BLANK } from '../shared/section-header-blank-slide-master-v2';

export const talkToUsSlideV2 = (): Slide => ({
  slideMaster: SECTION_HEADER_BLANK,
  texts: [
    {
      text: [
        { text: 'Talk to us!', options: { breakLine: true } },
        { text: "We're here for you." },
      ],
      options: {
        fontSize: 36,
        fontFace: DEFAULT_FONT,
        color: themeV2.colors.white,
        bold: true,
        align: 'center',
        h: 2.09,
        w: 6.82,
        x: 3.26,
        y: 2.24,
      },
    },
    {
      text: 'measurementaccountmanagement@inmarket.com',
      options: {
        fontSize: 18,
        fontFace: DEFAULT_FONT,
        color: themeV2.colors.white,
        align: 'center',
        h: 0.5,
        w: 6.82,
        x: 3.26,
        y: 4,
      },
    },
  ],
  images: [
    {
      path: inmarketLogo,
      x: 5.66,
      y: 4.82,
      w: 2.01,
      h: 0.35,
    },
  ],
});
